// assets
import AuditOutlined from '@ant-design/icons/AuditOutlined';

// icons
const icons = { AuditOutlined };

// ==============================|| MENU ITEMS - AUDIT (root only) ||============================== //

const audit = {
  id: 'audit',
  title: 'Audit',
  type: 'item',
  url: '/audit',
  icon: icons.AuditOutlined,
  rootOnly: true
};

export default audit;
